import { useEffect } from 'react';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { Z_INDEX } from 'src/constants/zIndex';

interface Params {
	zIndex: number;
}

/**
 * Handles showing and hiding the popup overlay.
 */
export default function usePopupOverlay({ zIndex }: Params) {
	const setVelocityStore = useVelocityStore((s) => s.set);
	const isMobileScreenSize = useIsMobileScreenSize();

	useEffect(() => {
		setVelocityStore((s) => {
			s.popups.overlay.show = true;
			s.popups.overlay.zIndex = zIndex - 1;
		});

		return () => {
			// On mobile, when a user presses outside of the popup, any interactive element
			// directly underneath the press will also be triggered. This is due to a synthetic
			// click event being fired by `touchend`. So, we need to delay removing the overlay
			// just long enough to run `preventDefault` on `touchend`. From testing, `200` has
			// so far worked consistently across both iOS and Android.
			setTimeout(
				() => {
					setVelocityStore((s) => {
						s.popups.overlay.show = false;
						s.popups.overlay.zIndex = Z_INDEX.popup;
					});
				},
				isMobileScreenSize ? 200 : 0
			);
		};
	}, [isMobileScreenSize]);
}
